import Toolbar from "../toolbar/Toolbar";
function ReUseableHeader(props) {
  return (
    <>
      <div className="HeaderBgImage">
        <div className="p-2">
          <Toolbar style="text-black" />
        </div>
        <div className="py-5 mt-4">
          <p className="display-4 fw-normal d-flex justify-content-center">
            {props.head}
          </p>
          <div className="d-flex justify-content-center">
            <a className="text-muted text-decoration-none">{props.subHead1}</a>
            <span className="mx-2">|</span>

            <a className="text-decoration-none text-black pb-5">
              {props.subHead2}
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReUseableHeader;
